export class MissingAccessTokenError extends Error {
  constructor() {
    super('No access token');
    this.name = 'MissingAccessTokenError';
  }
}

export class MissingRefreshTokenError extends Error {
  constructor() {
    super('No refresh token');
    this.name = 'MissingRefreshTokenError';
  }
}

export class TokenStorageUnavailableError extends Error {
  constructor() {
    super('Secure token storage is unavailable');
    this.name = 'TokenStorageUnavailableError';
  }
}
